<mat-spinner  [diameter]="50" style="margin: 0 auto;"></mat-spinner>  
<span>{{data}}</span> 